import { createSlice } from "@reduxjs/toolkit";
import { IDLE, LOADING, SAVING } from "@constants";
import { getFromServerTopic } from "@utility/slice";

const SLICE = "wellstatFuture";

export const getFromServer = (action, payloadFn) =>
  getFromServerTopic({ topic: SLICE, action, payloadFn });

export const getFutureData = getFromServer("getFutureData");

export const slice = createSlice({
  name: SLICE,
  initialState: {
    futureData: [],
    status: LOADING,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getFutureData.fulfilled, (state, action) => {
      state.futureData = action.payload.response;
      state.status = IDLE;
    });
  },
});

export const INITIAL_STATE = slice.getInitialState();

export default slice.reducer;
